// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.criteria-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.criteria-modal {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  /* 고정 크기 — 탭 전환 시 창 크기 변동 방지 */
  width: calc(90vw / var(--app-zoom, 1));
  height: calc(80vh / var(--app-zoom, 1));
  max-width: 1400px;
  max-height: calc(95vh / var(--app-zoom, 1));
  min-width: 640px;
  min-height: 440px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* 사용자 리사이즈 허용 (브라우저 기본 핸들: 우하단) */
  resize: both;
}

.criteria-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.criteria-modal-header h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.criteria-modal-close {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  padding: 4px;
  display: flex;
  align-items: center;
}

.criteria-modal-close:hover {
  color: #333;
}

.criteria-modal-tabs {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.criteria-tab {
  flex: 1 1;
  padding: 12px 20px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
}

.criteria-tab:hover {
  color: #374151;
  background: white;
}

.criteria-tab.active {
  color: #3b82f6;
  border-bottom-color: #3b82f6;
  background: white;
}

.criteria-modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ===== 좌측 사이드바 + 우측 워크페인 분할 레이아웃 ===== */
.criteria-body-split {
  flex-direction: row;
  gap: 0;
  padding: 0;
  overflow: hidden;
}

.criteria-sidebar {
  width: 230px;
  min-width: 230px;
  max-width: 260px;
  border-right: 1px solid #e5e7eb;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 10px;
  overflow-y: auto;
}

.criteria-workpane {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.criteria-inner-tabs {
  flex-shrink: 0;
}

.criteria-workpane-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 쿼리 탭 — 좌측 목록이 사이드바로 이동했으므로 편집기만 전폭 */
.criteria-query-section-noleft {
  display: block !important;
  grid-template-columns: none !important;
  gap: 0 !important;
}

/* 스케줄 탭 — 단일 기준 카드 */
.criteria-schedule-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.criteria-schedule-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #f3f4f6;
}

.criteria-schedule-fields {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.criteria-schedule-value {
  padding: 8px 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 12.5px;
  color: #374151;
}

.criteria-schedule-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: #f9fafb;
  border-radius: 6px;
  font-size: 12px;
  color: #374151;
}

/* ===== 다크모드 ===== */
[data-theme="dark"] .criteria-sidebar {
  background: var(--color-bg-secondary);
  border-right-color: var(--color-border);
}

[data-theme="dark"] .criteria-schedule-card {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
}

[data-theme="dark"] .criteria-schedule-card-head {
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .criteria-schedule-value {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text);
}

[data-theme="dark"] .criteria-schedule-summary {
  background: var(--color-bg-secondary);
  color: var(--color-text-secondary);
}

.criteria-message-overlay {
  position: relative;
  height: 0;            /* 레이아웃 공간 차지하지 않음 — 아래 body/footer 가 밀리지 않음 */
  overflow: visible;
  z-index: 30;
}

.criteria-message-overlay .criteria-message {
  position: absolute;
  top: 8px;
  left: 20px;
  right: 20px;
  margin: 0;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
}

.criteria-message {
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 12.5px;
  animation: slideDown 0.3s ease;
}

.criteria-message-success {
  background: #d1fae5;
  color: #065f46;
  border: 1px solid #6ee7b7;
}

.criteria-message-error {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.criteria-section {
  max-width: 300px;
}

.criteria-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.criteria-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #374151;
  background: white;
  cursor: pointer;
}

.criteria-select:hover {
  border-color: #3b82f6;
}

.criteria-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.criteria-query-section {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 20px;
  flex: 1 1;
}

.criteria-query-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.criteria-query-item {
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  font-size: 14px;
  text-align: left;
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.criteria-query-item:hover {
  border-color: #3b82f6;
  background: #eff6ff;
}

.criteria-query-item.active {
  border-color: #3b82f6;
  background: #dbeafe;
  font-weight: 500;
}

.criteria-query-item:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.criteria-override-badge {
  font-size: 12px;
  color: #f97316;
  margin-left: auto;
}

.criteria-query-editor {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.criteria-query-textarea {
  flex: 1 1;
  min-height: 140px;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
  font-family: var(--font-mono);
  color: #374151;
  background: white;
  resize: vertical;
}

/* SELECT / INSERT 영역 비율 조정 — SELECT 가 더 자주 편집되므로 더 크게. */
.criteria-query-textarea.select-area {
  min-height: 200px;     /* SELECT — 넉넉히 */
}
.criteria-query-textarea.insert-area {
  min-height: 80px;      /* INSERT — 짧게 (특히 builtin 자동생성 1줄 SQL) */
}

.criteria-group-label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  /* 묶음 사이는 보통의 실선 — 점선은 어색했다(2026-10-03) */
  margin-top: 10px;
  padding: 8px 2px 2px;
  border-top: 1px solid #e5e7eb;
}

.criteria-group-label:first-child {
  border-top: none;
  margin-top: 0;
}

.criteria-group-label-with-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.criteria-btn-icon {
  border: none;
  background: #eef2ff;
  color: #3b82f6;
  border-radius: 4px;
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.criteria-btn-icon:hover:not(:disabled) {
  background: #c7d2fe;
}

.criteria-btn-icon:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.criteria-empty-hint {
  font-size: 12px;
  color: #9ca3af;
  padding: 4px 2px;
}

/* 탭 진입 시 상단에 표시되는 안내 박스 (collapsible).
   <details><summary>축약</summary><div>상세</div></details> 구조 사용. */
.criteria-tab-intro {
  font-size: 12px;
  line-height: 1.5;
  color: #4b5563;
  background: #f0f7ff;
  border: 1px solid #c7dcfa;
  border-left: 3px solid #3b82f6;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 10px;
}
.criteria-tab-intro > summary {
  cursor: pointer;
  list-style: none;       /* 기본 화살표 marker 제거 (커스텀 표시 사용) */
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  padding-left: 16px;
  outline: none;
}
.criteria-tab-intro > summary::-webkit-details-marker { display: none; }
/* 커스텀 화살표 — 접힘: ▶, 펼침: ▼ (open 시 회전) */
.criteria-tab-intro > summary::before {
  content: '▶';
  position: absolute;
  left: 0;
  top: 0;
  font-size: 9px;
  color: #3b82f6;
  transition: transform 150ms ease;
}
.criteria-tab-intro[open] > summary::before {
  transform: rotate(90deg);
}
.criteria-tab-intro .criteria-intro-more {
  font-style: italic;
  font-size: 11px;
  color: #6b7280;
  margin-left: 4px;
  font-weight: normal;
}
.criteria-tab-intro[open] .criteria-intro-more {
  display: none;          /* 펼친 후엔 안내 텍스트 숨김 */
}
.criteria-tab-intro .criteria-intro-body {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(59, 130, 246, 0.25);
}
.criteria-tab-intro .criteria-intro-body ul {
  margin: 0;
  padding-left: 18px;
  list-style: disc;
}
.criteria-tab-intro strong {
  color: #1e3a8a;
}
.criteria-tab-intro code {
  background: rgba(59, 130, 246, 0.12);
  color: #1e40af;
  padding: 0 4px;
  border-radius: 3px;
  font-family: var(--font-mono);
  font-size: 11px;
}

/* 다크 모드 */
[data-theme="dark"] .criteria-tab-intro {
  color: var(--color-text);
  background: rgba(59, 130, 246, 0.08);
  border-color: rgba(99, 130, 200, 0.4);
  border-left-color: #6cb6ff;
}
[data-theme="dark"] .criteria-tab-intro > summary::before { color: #6cb6ff; }
[data-theme="dark"] .criteria-tab-intro .criteria-intro-more { color: var(--color-text-muted); }
[data-theme="dark"] .criteria-tab-intro .criteria-intro-body {
  border-top-color: rgba(108, 182, 255, 0.25);
}
[data-theme="dark"] .criteria-tab-intro strong { color: #93c5fd; }
[data-theme="dark"] .criteria-tab-intro code {
  background: rgba(108, 182, 255, 0.18);
  color: #93c5fd;
}

.criteria-field-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.criteria-field-inline {
  flex-direction: row;
  gap: 12px;
}

.criteria-text-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12.5px;
  color: #374151;
  background: white;
  box-sizing: border-box;
}

.criteria-text-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.criteria-text-input:disabled {
  opacity: 0.7;
  background: #f3f4f6;
}

.criteria-query-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.criteria-query-textarea:disabled {
  opacity: 0.6;
  background: #f3f4f6;
}

.criteria-query-actions {
  display: flex;
  gap: 8px;
}

.criteria-mapping-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 1;
}

.criteria-mapping-header {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.criteria-mapping-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  overflow: hidden;
}

.criteria-mapping-table thead {
  background: #f3f4f6;
}

.criteria-mapping-table th {
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #d1d5db;
}

.criteria-mapping-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #e5e7eb;
  color: #374151;
}

.criteria-mapping-table tbody tr:hover {
  background: #f9fafb;
}

.criteria-mapping-new {
  background: #f9fafb;
}

.criteria-mapping-table input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 12px;
}

.criteria-mapping-table input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.criteria-type-select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}

.criteria-type-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.criteria-btn-delete,
.criteria-btn-add {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.criteria-btn-delete {
  background: #fee2e2;
  color: #991b1b;
}

.criteria-btn-delete:hover:not(:disabled) {
  background: #fca5a5;
}

.criteria-btn-delete:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.criteria-btn-add {
  background: #d1fae5;
  color: #065f46;
}

.criteria-btn-add:hover:not(:disabled) {
  background: #6ee7b7;
}

.criteria-btn-add:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.criteria-mapping-actions {
  display: flex;
  gap: 8px;
}

.criteria-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.criteria-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.criteria-btn-primary {
  background: #3b82f6;
  color: white;
}

.criteria-btn-primary:hover:not(:disabled) {
  background: #2563eb;
}

.criteria-btn-danger {
  background: #ef4444;
  color: white;
}

.criteria-btn-danger:hover:not(:disabled) {
  background: #dc2626;
}

.criteria-btn-secondary {
  background: #e5e7eb;
  color: #374151;
}

.criteria-btn-secondary:hover:not(:disabled) {
  background: #d1d5db;
}

.criteria-modal-footer {
  display: flex;
  gap: 8px;
  padding: 16px 20px;
  border-top: 1px solid #e5e7eb;
  justify-content: flex-end;
}

/* Dark mode */
[data-theme="dark"] .criteria-modal {
  background: var(--color-bg-tertiary);
  color: var(--color-text);
}

[data-theme="dark"] .criteria-modal-header {
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .criteria-modal-header h2 {
  color: var(--color-text);
}

[data-theme="dark"] .criteria-modal-close {
  color: var(--color-text-muted);
}

[data-theme="dark"] .criteria-modal-close:hover {
  color: var(--color-text);
}

[data-theme="dark"] .criteria-modal-tabs {
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .criteria-tab {
  color: var(--color-text-muted);
}

[data-theme="dark"] .criteria-tab:hover {
  background: var(--color-hover);
  color: var(--color-text);
}

[data-theme="dark"] .criteria-tab.active {
  color: var(--color-accent-fg);
  background: var(--color-bg-tertiary);
}

[data-theme="dark"] .criteria-label {
  color: var(--color-text-secondary);
}

[data-theme="dark"] .criteria-select {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}

[data-theme="dark"] .criteria-select:hover {
  border-color: var(--color-hover-border, #5a5a5a);
}

[data-theme="dark"] .criteria-select:focus {
  border-color: var(--color-accent-fg);
}

[data-theme="dark"] .criteria-message-success {
  background: #1a3a2a;
  color: #4caf50;
  border-color: #2e7d32;
}

[data-theme="dark"] .criteria-message-error {
  background: #3a1a1a;
  color: #ef5350;
  border-color: #c62828;
}

[data-theme="dark"] .criteria-query-item {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text);
}

[data-theme="dark"] .criteria-query-item:hover {
  background: var(--color-hover);
  border-color: var(--color-hover-border, #5a5a5a);
}

[data-theme="dark"] .criteria-query-item.active {
  background: #264f78;
  border-color: var(--color-accent-fg);
}

[data-theme="dark"] .criteria-query-textarea {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}

[data-theme="dark"] .criteria-query-textarea:focus {
  border-color: var(--color-accent-fg);
}

[data-theme="dark"] .criteria-query-textarea:disabled {
  background: var(--color-bg-secondary);
}

[data-theme="dark"] .criteria-mapping-table {
  border-color: var(--color-border);
}

[data-theme="dark"] .criteria-mapping-table thead {
  background: var(--color-bg-secondary);
}

[data-theme="dark"] .criteria-mapping-table th {
  color: var(--color-text);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .criteria-mapping-table td {
  border-bottom-color: var(--color-border);
  color: var(--color-text);
}

[data-theme="dark"] .criteria-mapping-table tbody tr:hover {
  background: var(--color-hover);
}

[data-theme="dark"] .criteria-mapping-new {
  background: var(--color-bg-secondary);
}

[data-theme="dark"] .criteria-mapping-table input,
[data-theme="dark"] .criteria-type-select {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}

[data-theme="dark"] .criteria-mapping-table input:focus,
[data-theme="dark"] .criteria-type-select:focus {
  border-color: var(--color-accent-fg);
}

[data-theme="dark"] .criteria-modal-footer {
  border-top-color: var(--color-border);
}

[data-theme="dark"] .criteria-btn-secondary {
  background: var(--color-bg-secondary);
  color: var(--color-text);
  border: 1px solid var(--color-border);
}

[data-theme="dark"] .criteria-btn-secondary:hover:not(:disabled) {
  background: var(--color-hover);
}

[data-theme="dark"] .criteria-btn-delete {
  background: rgba(239, 68, 68, 0.2); /* Red tint */
  color: #fca5a5;
}

[data-theme="dark"] .criteria-btn-delete:hover:not(:disabled) {
  background: rgba(239, 68, 68, 0.4);
}

[data-theme="dark"] .criteria-btn-add {
  background: rgba(16, 185, 129, 0.2); /* Green tint */
  color: #6ee7b7;
}

[data-theme="dark"] .criteria-btn-add:hover:not(:disabled) {
  background: rgba(16, 185, 129, 0.4);
}

[data-theme="dark"] .criteria-btn-primary {
  background: #2563eb;
  color: #fff;
}

[data-theme="dark"] .criteria-btn-primary:hover:not(:disabled) {
  background: #1d4ed8;
}

[data-theme="dark"] .criteria-btn-icon {
  background: rgba(59, 130, 246, 0.2);
  color: #60a5fa;
}

[data-theme="dark"] .criteria-btn-icon:hover:not(:disabled) {
  background: var(--color-hover);
}

/* ===== 스케줄 탭 (통합) ===== */
.criteria-schedule-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 1;
}

.criteria-groups-table {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  overflow: hidden;
}

.criteria-groups-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.criteria-groups-table thead {
  background: #f3f4f6;
}

.criteria-groups-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
}

.criteria-groups-table td {
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
  color: #374151;
  vertical-align: middle;
}

.criteria-groups-table tbody tr:hover {
  background: #f9fafb;
}

.criteria-status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.criteria-status-badge.active {
  background: #d1fae5;
  color: #065f46;
}

.criteria-status-badge.inactive {
  background: #fee2e2;
  color: #991b1b;
}

.criteria-schedule-actions {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.criteria-btn-small {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.criteria-btn-small:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.criteria-btn-small.criteria-btn-primary {
  background: #3b82f6;
  color: white;
}

.criteria-btn-small.criteria-btn-primary:hover:not(:disabled) {
  background: #2563eb;
}

.criteria-btn-small.criteria-btn-success {
  background: #10b981;
  color: white;
}

.criteria-btn-small.criteria-btn-success:hover:not(:disabled) {
  background: #059669;
}

.criteria-btn-small.criteria-btn-danger {
  background: #ef4444;
  color: white;
}

.criteria-btn-small.criteria-btn-danger:hover:not(:disabled) {
  background: #dc2626;
}

.criteria-btn-small.criteria-btn-secondary {
  background: #e5e7eb;
  color: #374151;
}

.criteria-btn-small.criteria-btn-secondary:hover:not(:disabled) {
  background: #d1d5db;
}

.criteria-select-inline {
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  cursor: pointer;
}

.criteria-select-inline:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

/* ===== 스케줄 탭 — 다크모드 ===== */
[data-theme="dark"] .criteria-groups-table {
  border-color: var(--color-border);
}

[data-theme="dark"] .criteria-groups-table thead {
  background: var(--color-bg-secondary);
}

[data-theme="dark"] .criteria-groups-table th {
  color: var(--color-text);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .criteria-groups-table td {
  border-bottom-color: var(--color-border);
  color: var(--color-text);
}

[data-theme="dark"] .criteria-groups-table tbody tr:hover {
  background: var(--color-hover);
}

[data-theme="dark"] .criteria-status-badge.active {
  background: rgba(16, 185, 129, 0.2);
  color: #6ee7b7;
}

[data-theme="dark"] .criteria-status-badge.inactive {
  background: rgba(239, 68, 68, 0.2);
  color: #fca5a5;
}

[data-theme="dark"] .criteria-select-inline {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}

[data-theme="dark"] .criteria-select-inline:focus {
  border-color: var(--color-accent-fg);
}

[data-theme="dark"] .criteria-btn-small.criteria-btn-secondary {
  background: var(--color-bg-secondary);
  color: var(--color-text);
  border: 1px solid var(--color-border);
}

[data-theme="dark"] .criteria-btn-small.criteria-btn-secondary:hover:not(:disabled) {
  background: var(--color-hover);
}

[data-theme="dark"] .criteria-btn-small.criteria-btn-danger {
  background: rgba(239, 68, 68, 0.2);
  color: #fca5a5;
}

[data-theme="dark"] .criteria-btn-small.criteria-btn-danger:hover:not(:disabled) {
  background: rgba(239, 68, 68, 0.4);
}

[data-theme="dark"] .criteria-btn-small.criteria-btn-success {
  background: rgba(16, 185, 129, 0.2);
  color: #6ee7b7;
}

[data-theme="dark"] .criteria-btn-small.criteria-btn-success:hover:not(:disabled) {
  background: rgba(16, 185, 129, 0.4);
}

[data-theme="dark"] .criteria-btn-small.criteria-btn-primary {
  background: #2563eb;
  color: #fff;
}

[data-theme="dark"] .criteria-btn-small.criteria-btn-primary:hover:not(:disabled) {
  background: #1d4ed8;
}

/* ===== 스케줄 — 펼침/타입 뱃지/요약/상세 이력 ===== */
.criteria-expand-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #6b7280;
  font-size: 10px;
  padding: 2px 4px;
  line-height: 1;
  border-radius: 3px;
}

.criteria-expand-btn:hover {
  background: #e5e7eb;
  color: #111827;
}

.criteria-group-name-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.criteria-group-name {
  font-weight: 500;
}

.criteria-type-badge {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.5;
  white-space: nowrap;
}

.criteria-type-builtin {
  background: #dbeafe;
  color: #1e40af;
  border: 1px solid #bfdbfe;
}

.criteria-type-custom {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fde68a;
}

.criteria-summary-cell {
  font-size: 12px;
  color: #374151;
  min-width: 170px;
}

.criteria-summary-label {
  color: #6b7280;
}

.criteria-summary-sub {
  color: #9ca3af;
  font-size: 11px;
  margin-top: 2px;
}

.criteria-row-expanded > td {
  background: #f3f4f6;
}

.criteria-row-detail > td {
  padding: 0 !important;
  background: #fafafa;
  border-bottom: 1px solid #e5e7eb;
}

.criteria-history-detail {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.criteria-history-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.criteria-history-tablewrap {
  max-height: 280px;
  overflow: auto;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: white;
}

.criteria-history-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  font-family: var(--font-mono);
}

.criteria-history-table th {
  position: sticky;
  top: 0;
  background: #f3f4f6;
  color: #374151;
  font-weight: 600;
  padding: 6px 8px;
  border-bottom: 1px solid #d1d5db;
  text-align: left;
  white-space: nowrap;
}

.criteria-history-table td {
  padding: 5px 8px;
  border-bottom: 1px solid #f3f4f6;
  color: #374151;
  white-space: nowrap;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.criteria-history-table tbody tr:hover {
  background: #fafafa;
}

/* ===== 스케줄 — 다크모드 보강 ===== */
[data-theme="dark"] .criteria-expand-btn {
  color: var(--color-text-muted);
}

[data-theme="dark"] .criteria-expand-btn:hover {
  background: var(--color-hover);
  color: var(--color-text);
}

[data-theme="dark"] .criteria-type-builtin {
  background: rgba(59, 130, 246, 0.2);
  color: #93c5fd;
  border-color: rgba(59, 130, 246, 0.4);
}

[data-theme="dark"] .criteria-type-custom {
  background: rgba(245, 158, 11, 0.2);
  color: #fcd34d;
  border-color: rgba(245, 158, 11, 0.4);
}

[data-theme="dark"] .criteria-summary-cell {
  color: var(--color-text-secondary);
}

[data-theme="dark"] .criteria-summary-label,
[data-theme="dark"] .criteria-summary-sub {
  color: var(--color-text-muted);
}

[data-theme="dark"] .criteria-row-expanded > td {
  background: var(--color-hover);
}

[data-theme="dark"] .criteria-row-detail > td {
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .criteria-history-tablewrap {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
}

[data-theme="dark"] .criteria-history-table th {
  background: var(--color-bg-secondary);
  color: var(--color-text);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .criteria-history-table td {
  color: var(--color-text);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .criteria-history-table tbody tr:hover {
  background: var(--color-hover);
}

/* ===== 오라클 성능 분석과 모양 맞춤 (2026-10-03) =====
   앞의 규칙은 두고 뒤에서 덮는다. 다크 규칙([data-theme] 이 붙어 더 구체적)은 그대로 이긴다. */
.criteria-modal-tabs {
  align-items: center;
  gap: 4px;
  padding: 0 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
}
.criteria-tab {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  font-size: 13px;
  white-space: nowrap;
  transition: color 150ms ease, border-color 150ms ease;
}
.criteria-tab:hover { background: none; }
.criteria-tab.active { background: none; }
.criteria-tab > svg { display: block; flex-shrink: 0; }
.criteria-workpane-body { padding: 14px 16px; gap: 14px; }
.criteria-sidebar { padding: 12px 10px; }
.criteria-query-item { padding: 7px 10px; font-size: 12.5px; border-radius: 5px; transition: background-color 150ms ease, border-color 150ms ease; }
.criteria-query-item.active { background: rgba(59, 130, 246, 0.1); color: #1d4ed8; font-weight: 600; }
.criteria-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  box-sizing: border-box;
  padding: 0 14px;
  border: 1px solid transparent;
  font-size: 13px;
  line-height: 1;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}
.criteria-btn-secondary { border-color: #d1d5db; }
.criteria-btn-small { transition: background-color 150ms ease, color 150ms ease; }
.criteria-select { padding: 0 10px; height: 30px; font-size: 12.5px; border-radius: 4px; }
.criteria-modal-footer { padding: 10px 16px; background: #f8f9fa; border-top-color: #e0e0e0; }
[data-theme="dark"] .criteria-modal-tabs { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); }
[data-theme="dark"] .criteria-tab:hover, [data-theme="dark"] .criteria-tab.active { background: none; }
[data-theme="dark"] .criteria-query-item.active { background: rgba(59, 130, 246, 0.18); color: #93c5fd; }
[data-theme="dark"] .criteria-modal-footer { background: var(--color-bg-secondary); border-top-color: var(--color-border); }
@media (prefers-reduced-motion: reduce) {
  .criteria-tab, .criteria-query-item, .criteria-btn, .criteria-btn-small { transition: none; }
}
[data-theme="dark"] .criteria-group-label { border-top-color: var(--color-border); }

/* ===== 세션 분석 · 오라클 성능 분석 기준으로 맞춤 (2026-10-03, 모니터링 메뉴 4개 창 공통) =====
   본문 12px · 표(머리 6/8px 회색 바탕 + 아래 2px 선, 칸 5/8px + 1px 선) · 버튼·입력 30px · 필터는 리본 · 발 영역 회색 줄.
   앞 규칙을 지우지 않고 뒤에서 덮는다(분리 창·전체 화면이 같은 클래스를 쓴다). 색 전환만(all 트랜지션 아님). */
.criteria-label { font-size: 12px; font-weight: 600; }
.criteria-text-input { height: 30px; box-sizing: border-box; padding: 0 10px; font-size: 12.5px; border-radius: 4px; }
.criteria-mapping-table, .criteria-groups-table table, .criteria-history-table { font-size: 12px; }
.criteria-mapping-table th, .criteria-groups-table th, .criteria-history-table th {
  padding: 6px 8px; background: #f8f9fa; border-bottom: 2px solid #d0d5db; color: #333; font-weight: 600; white-space: nowrap;
}
.criteria-mapping-table td, .criteria-groups-table td, .criteria-history-table td { padding: 5px 8px; border-bottom: 1px solid #eee; color: #374151; }
[data-theme="dark"] .criteria-mapping-table th, [data-theme="dark"] .criteria-groups-table th, [data-theme="dark"] .criteria-history-table th {
  background: var(--color-bg-secondary); border-bottom-color: var(--color-border); color: var(--color-text);
}
[data-theme="dark"] .criteria-mapping-table td, [data-theme="dark"] .criteria-groups-table td, [data-theme="dark"] .criteria-history-table td {
  border-bottom-color: var(--color-border); color: var(--color-text);
}

/* 적재 대상이 내장 저장소일 때의 안내(2026-10-28) */
.criteria-hint { margin-top: 4px; font-size: 11px; line-height: 1.5; color: var(--color-text-muted, #888); animation: criteria-hint-fade 150ms ease-out; }
@keyframes criteria-hint-fade { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }
@media (prefers-reduced-motion: reduce) { .criteria-hint { animation: none; } }

/* ===== 2026-10-28 구조 개편 — 왼쪽 연결 목록 · 위쪽 기준 목록 · 연결별 수집 설정 카드 ===== */
.criteria-conn-item { display: flex; flex-direction: column; align-items: flex-start; gap: 2px; text-align: left; }
.criteria-conn-name { font-weight: 600; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.criteria-conn-sub { font-size: 11px; color: var(--color-text-muted, #888); font-weight: 400; }
.criteria-conn-sub.on { color: #16a34a; }

.criteria-topbar {
  display: flex; flex-wrap: wrap; align-items: center; gap: 4px 6px;
  padding: 8px 14px; border-bottom: 1px solid var(--color-border, #e5e7eb);
  animation: criteria-topbar-fade 150ms ease-out;
}
.criteria-topbar-label { font-size: 11px; font-weight: 600; color: var(--color-text-muted, #6b7280); margin-right: 2px; }
.criteria-topbar-sep { width: 1px; height: 18px; background: var(--color-border, #e5e7eb); margin: 0 4px; }
.criteria-topbar-empty { font-size: 11px; color: var(--color-text-muted, #999); }
.criteria-chip {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 3px 10px; border: 1px solid var(--color-border, #d1d5db); border-radius: 12px;
  background: var(--color-bg, #fff); color: var(--color-text, #374151); font-size: 12px; cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}
.criteria-chip:hover:not(:disabled) { border-color: #3b82f6; }
.criteria-chip.active { border-color: #3b82f6; background: color-mix(in srgb, #3b82f6 14%, transparent); color: var(--color-accent, #2563eb); font-weight: 600; }
.criteria-chip:disabled { opacity: 0.6; cursor: not-allowed; }
.criteria-chip-star { color: #f97316; }
.criteria-scope { padding: 6px 14px; font-size: 11.5px; color: var(--color-text-secondary, #555); background: var(--color-bg-secondary, #f8fafc); border-bottom: 1px solid var(--color-border, #e5e7eb); transition: background-color 150ms ease, color 150ms ease; }
.criteria-scope.conn { background: color-mix(in srgb, #f97316 10%, transparent); color: var(--color-text, #222); }
.criteria-schedule-section .criteria-schedule-card + .criteria-schedule-card { margin-top: 10px; }
[data-theme="dark"] .criteria-chip { background: #2b2b2b; border-color: #444; color: #ddd; }
[data-theme="dark"] .criteria-scope { background: #252526; }

@keyframes criteria-topbar-fade { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }
@media (prefers-reduced-motion: reduce) {
  .criteria-topbar { animation: none; }
  .criteria-chip, .criteria-scope { transition: none; }
}
.criteria-message-info { background: #dbeafe; color: #1e3a8a; border: 1px solid #93c5fd; }
[data-theme="dark"] .criteria-message-info { background: #1e2a44; color: #93c5fd; border-color: #2c4a7a; }
/* 연결별 수집 설정 표(2026-10-28) */
.criteria-sched-table { width: 100%; border-collapse: collapse; font-size: 12.5px; margin-top: 8px; animation: criteria-topbar-fade 150ms ease-out; }
.criteria-sched-table th { text-align: left; font-weight: 600; font-size: 11.5px; color: var(--color-text-muted, #6b7280); padding: 6px 8px; border-bottom: 1px solid var(--color-border, #e5e7eb); white-space: nowrap; }
.criteria-sched-table td { padding: 6px 8px; border-bottom: 1px solid var(--color-border, #eef0f3); vertical-align: middle; }
.criteria-sched-table tbody tr { transition: background-color 150ms ease; }
.criteria-sched-table tbody tr:hover { background: var(--color-hover, rgba(0, 0, 0, 0.03)); }
.criteria-sched-table .criteria-select { padding: 3px 6px; font-size: 12px; }
.criteria-sched-actions { white-space: nowrap; text-align: right; }
.criteria-sched-actions .criteria-btn-small + .criteria-btn-small { margin-left: 4px; }
.criteria-sched-detail > td { background: var(--color-bg-secondary, #f8fafc); }
[data-theme="dark"] .criteria-sched-detail > td { background: #252526; }
@media (prefers-reduced-motion: reduce) { .criteria-sched-table { animation: none; } .criteria-sched-table tbody tr { transition: none; } }
/* 표가 칸보다 넓으면 표만 가로로 — 바깥 칸이 밀려 왼쪽 연결 목록 밑으로 들어갔다(2026-10-28 화면 확인) */
.criteria-workpane { min-width: 0; }
.criteria-workpane-body { overflow-x: hidden; }
.criteria-sched-wrap { overflow-x: auto; max-width: 100%; }
.criteria-body-split > .criteria-sidebar { position: relative; z-index: 1; }
.criteria-sched-actions { white-space: normal; }
.criteria-sched-actions > * { margin: 2px 0 2px 4px; }
.criteria-sched-actions .criteria-btn-small + .criteria-btn-small { margin-left: 4px; }
.criteria-sched-table td:not(.criteria-sched-actions) { white-space: nowrap; }
.criteria-sched-table td:first-child { white-space: normal; }
.criteria-sched-actions { white-space: nowrap; }
.criteria-icon-act {
  display: inline-flex; align-items: center; justify-content: center; width: 26px; height: 26px; margin-left: 3px;
  border: 1px solid var(--color-border, #d1d5db); border-radius: 5px; background: var(--color-bg, #fff); color: var(--color-text-secondary, #555); cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;
}
.criteria-icon-act:hover:not(:disabled), .criteria-icon-act.on { border-color: #3b82f6; color: #2563eb; }
.criteria-icon-act.primary { color: #2563eb; }
.criteria-icon-act.danger { color: #dc2626; }
.criteria-icon-act:disabled { opacity: 0.5; cursor: not-allowed; }
[data-theme="dark"] .criteria-icon-act { background: #2b2b2b; border-color: #444; color: #ccc; }
@media (prefers-reduced-motion: reduce) { .criteria-icon-act { transition: none; } }
.criteria-body-split > .criteria-sidebar { width: 200px; min-width: 180px; }
.criteria-sched-table th, .criteria-sched-table td { padding: 5px 6px; }
.criteria-sched-table td:first-child { min-width: 96px; }
.criteria-sched-table td:first-child .criteria-type-badge { margin-left: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/monitoring/MonitoringCriteriaModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,8BAA8B;EAC9B,sCAAsC;EACtC,uCAAuC;EACvC,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,MAAM;EACN,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS,aAAa,8CAA8C;EACpE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,iBAAiB,MAAM,iBAAiB;AAC1C;AACA;EACE,gBAAgB,OAAO,yCAAyC;AAClE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;iEACiE;AACjE;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB,QAAQ,iCAAiC;EACzD,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;AACA,wDAAwD,aAAa,EAAE;AACvE,uCAAuC;AACvC;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,cAAc;EACd,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa,WAAW,oBAAoB;AAC9C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,wBAAwB;EACxB,oCAAoC;EACpC,qCAAqC;EACrC,0BAA0B;AAC5B;AACA,4DAA4D,cAAc,EAAE;AAC5E,+DAA+D,8BAA8B,EAAE;AAC/F;EACE,2CAA2C;AAC7C;AACA,iDAAiD,cAAc,EAAE;AACjE;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC,EAAE,aAAa;EACjD,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC,EAAE,eAAe;EACpD,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,6BAA6B;AAC7B;EACE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;gEACgE;AAChE;EACE,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,qDAAqD;AACvD;AACA,sBAAsB,gBAAgB,EAAE;AACxC,uBAAuB,gBAAgB,EAAE;AACzC,sBAAsB,cAAc,EAAE,cAAc,EAAE;AACtD,0BAA0B,kBAAkB,EAAE,SAAS,EAAE;AACzD,oBAAoB,kBAAkB,EAAE;AACxC,uBAAuB,iBAAiB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,gEAAgE,EAAE;AACnJ,8BAA8B,mCAAmC,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACrG;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,kFAAkF;AACpF;AACA,0BAA0B,qBAAqB,EAAE;AACjD,sBAAsB,yDAAyD,EAAE;AACjF,mBAAmB,eAAe,EAAE,YAAY,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACzF,yBAAyB,kBAAkB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE;AAC7F,2CAA2C,qCAAqC,EAAE,wCAAwC,EAAE;AAC5H,oFAAoF,gBAAgB,EAAE;AACtG,kDAAkD,oCAAoC,EAAE,cAAc,EAAE;AACxG,6CAA6C,qCAAqC,EAAE,qCAAqC,EAAE;AAC3H;EACE,0EAA0E,gBAAgB,EAAE;AAC9F;AACA,4CAA4C,qCAAqC,EAAE;;AAEnF;;sEAEsE;AACtE,kBAAkB,eAAe,EAAE,gBAAgB,EAAE;AACrD,uBAAuB,YAAY,EAAE,sBAAsB,EAAE,eAAe,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACrH,iFAAiF,eAAe,EAAE;AAClG;EACE,gBAAgB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE,WAAW,EAAE,gBAAgB,EAAE,mBAAmB;AAC7H;AACA,oFAAoF,gBAAgB,EAAE,6BAA6B,EAAE,cAAc,EAAE;AACrJ;EACE,qCAAqC,EAAE,wCAAwC,EAAE,wBAAwB;AAC3G;AACA;EACE,wCAAwC,EAAE,wBAAwB;AACpE;;AAEA,qCAAqC;AACrC,iBAAiB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,oCAAoC,EAAE,4CAA4C,EAAE;AACzJ,gCAAgC,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AAC/H,0CAA0C,iBAAiB,eAAe,EAAE,EAAE;;AAE9E,sEAAsE;AACtE,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAClH,sBAAsB,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACzH,qBAAqB,eAAe,EAAE,oCAAoC,EAAE,gBAAgB,EAAE;AAC9F,wBAAwB,cAAc,EAAE;;AAExC;EACE,aAAa,EAAE,eAAe,EAAE,mBAAmB,EAAE,YAAY;EACjE,iBAAiB,EAAE,qDAAqD;EACxE,8CAA8C;AAChD;AACA,yBAAyB,eAAe,EAAE,gBAAgB,EAAE,uCAAuC,EAAE,iBAAiB,EAAE;AACxH,uBAAuB,UAAU,EAAE,YAAY,EAAE,wCAAwC,EAAE,aAAa,EAAE;AAC1G,yBAAyB,eAAe,EAAE,oCAAoC,EAAE;AAChF;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB,EAAE,8CAA8C,EAAE,mBAAmB;EACtF,iCAAiC,EAAE,iCAAiC,EAAE,eAAe,EAAE,eAAe;EACtG,kFAAkF;AACpF;AACA,sCAAsC,qBAAqB,EAAE;AAC7D,wBAAwB,qBAAqB,EAAE,wDAAwD,EAAE,mCAAmC,EAAE,gBAAgB,EAAE;AAChK,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;AAC7D,sBAAsB,cAAc,EAAE;AACtC,kBAAkB,iBAAiB,EAAE,iBAAiB,EAAE,wCAAwC,EAAE,8CAA8C,EAAE,qDAAqD,EAAE,yDAAyD,EAAE;AACpQ,uBAAuB,wDAAwD,EAAE,8BAA8B,EAAE;AACjH,+EAA+E,gBAAgB,EAAE;AACjG,qCAAqC,mBAAmB,EAAE,kBAAkB,EAAE,WAAW,EAAE;AAC3F,sCAAsC,mBAAmB,EAAE;;AAE3D,kCAAkC,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AACjI;EACE,mBAAmB,eAAe,EAAE;EACpC,kCAAkC,gBAAgB,EAAE;AACtD;AACA,yBAAyB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AACzF,6CAA6C,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACzG,4BAA4B;AAC5B,wBAAwB,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,eAAe,EAAE,8CAA8C,EAAE;AACpJ,2BAA2B,gBAAgB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,uCAAuC,EAAE,gBAAgB,EAAE,qDAAqD,EAAE,mBAAmB,EAAE;AACzN,2BAA2B,gBAAgB,EAAE,qDAAqD,EAAE,sBAAsB,EAAE;AAC5H,iCAAiC,uCAAuC,EAAE;AAC1E,uCAAuC,mDAAmD,EAAE;AAC5F,yCAAyC,gBAAgB,EAAE,eAAe,EAAE;AAC5E,0BAA0B,mBAAmB,EAAE,iBAAiB,EAAE;AAClE,oEAAoE,gBAAgB,EAAE;AACtF,8BAA8B,8CAA8C,EAAE;AAC9E,kDAAkD,mBAAmB,EAAE;AACvE,0CAA0C,wBAAwB,eAAe,EAAE,EAAE,iCAAiC,gBAAgB,EAAE,EAAE;AAC1I,qEAAqE;AACrE,qBAAqB,YAAY,EAAE;AACnC,0BAA0B,kBAAkB,EAAE;AAC9C,uBAAuB,gBAAgB,EAAE,eAAe,EAAE;AAC1D,2CAA2C,kBAAkB,EAAE,UAAU,EAAE;AAC3E,0BAA0B,mBAAmB,EAAE;AAC/C,8BAA8B,qBAAqB,EAAE;AACrD,oEAAoE,gBAAgB,EAAE;AACtF,wDAAwD,mBAAmB,EAAE;AAC7E,uCAAuC,mBAAmB,EAAE;AAC5D,0BAA0B,mBAAmB,EAAE;AAC/C;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY,EAAE,gBAAgB;EAC/G,8CAA8C,EAAE,kBAAkB,EAAE,iCAAiC,EAAE,wCAAwC,EAAE,eAAe;EAChK,kFAAkF;AACpF;AACA,iEAAiE,qBAAqB,EAAE,cAAc,EAAE;AACxG,6BAA6B,cAAc,EAAE;AAC7C,4BAA4B,cAAc,EAAE;AAC5C,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;AACjE,yCAAyC,mBAAmB,EAAE,kBAAkB,EAAE,WAAW,EAAE;AAC/F,0CAA0C,qBAAqB,gBAAgB,EAAE,EAAE;AACnF,2CAA2C,YAAY,EAAE,gBAAgB,EAAE;AAC3E,qDAAqD,gBAAgB,EAAE;AACvE,uCAAuC,eAAe,EAAE;AACxD,4DAA4D,cAAc,EAAE","sourcesContent":[".criteria-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1001;\r\n}\r\n\r\n.criteria-modal {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\r\n  /* 고정 크기 — 탭 전환 시 창 크기 변동 방지 */\r\n  width: calc(90vw / var(--app-zoom, 1));\r\n  height: calc(80vh / var(--app-zoom, 1));\r\n  max-width: 1400px;\r\n  max-height: calc(95vh / var(--app-zoom, 1));\r\n  min-width: 640px;\r\n  min-height: 440px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  /* 사용자 리사이즈 허용 (브라우저 기본 핸들: 우하단) */\r\n  resize: both;\r\n}\r\n\r\n.criteria-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 16px;\r\n  background: #f8f9fa;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.criteria-modal-header h2 {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.criteria-modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  color: #999;\r\n  padding: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.criteria-modal-close:hover {\r\n  color: #333;\r\n}\r\n\r\n.criteria-modal-tabs {\r\n  display: flex;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  background: #f9fafb;\r\n}\r\n\r\n.criteria-tab {\r\n  flex: 1;\r\n  padding: 12px 20px;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #6b7280;\r\n  transition: all 0.2s ease;\r\n  border-bottom: 2px solid transparent;\r\n  margin-bottom: -1px;\r\n}\r\n\r\n.criteria-tab:hover {\r\n  color: #374151;\r\n  background: white;\r\n}\r\n\r\n.criteria-tab.active {\r\n  color: #3b82f6;\r\n  border-bottom-color: #3b82f6;\r\n  background: white;\r\n}\r\n\r\n.criteria-modal-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n/* ===== 좌측 사이드바 + 우측 워크페인 분할 레이아웃 ===== */\r\n.criteria-body-split {\r\n  flex-direction: row;\r\n  gap: 0;\r\n  padding: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.criteria-sidebar {\r\n  width: 230px;\r\n  min-width: 230px;\r\n  max-width: 260px;\r\n  border-right: 1px solid #e5e7eb;\r\n  background: #fafafa;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  padding: 14px 10px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.criteria-workpane {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.criteria-inner-tabs {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.criteria-workpane-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n/* 쿼리 탭 — 좌측 목록이 사이드바로 이동했으므로 편집기만 전폭 */\r\n.criteria-query-section-noleft {\r\n  display: block !important;\r\n  grid-template-columns: none !important;\r\n  gap: 0 !important;\r\n}\r\n\r\n/* 스케줄 탭 — 단일 기준 카드 */\r\n.criteria-schedule-card {\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  background: #ffffff;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.criteria-schedule-card-head {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-bottom: 10px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n}\r\n\r\n.criteria-schedule-fields {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.criteria-schedule-value {\r\n  padding: 8px 12px;\r\n  background: #f9fafb;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  font-size: 12.5px;\r\n  color: #374151;\r\n}\r\n\r\n.criteria-schedule-summary {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 12px;\r\n  background: #f9fafb;\r\n  border-radius: 6px;\r\n  font-size: 12px;\r\n  color: #374151;\r\n}\r\n\r\n/* ===== 다크모드 ===== */\r\n[data-theme=\"dark\"] .criteria-sidebar {\r\n  background: var(--color-bg-secondary);\r\n  border-right-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-schedule-card {\r\n  background: var(--color-bg-tertiary);\r\n  border-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-schedule-card-head {\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-schedule-value {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-schedule-summary {\r\n  background: var(--color-bg-secondary);\r\n  color: var(--color-text-secondary);\r\n}\r\n\r\n.criteria-message-overlay {\r\n  position: relative;\r\n  height: 0;            /* 레이아웃 공간 차지하지 않음 — 아래 body/footer 가 밀리지 않음 */\r\n  overflow: visible;\r\n  z-index: 30;\r\n}\r\n\r\n.criteria-message-overlay .criteria-message {\r\n  position: absolute;\r\n  top: 8px;\r\n  left: 20px;\r\n  right: 20px;\r\n  margin: 0;\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.criteria-message {\r\n  padding: 10px 14px;\r\n  border-radius: 6px;\r\n  font-size: 12.5px;\r\n  animation: slideDown 0.3s ease;\r\n}\r\n\r\n.criteria-message-success {\r\n  background: #d1fae5;\r\n  color: #065f46;\r\n  border: 1px solid #6ee7b7;\r\n}\r\n\r\n.criteria-message-error {\r\n  background: #fee2e2;\r\n  color: #991b1b;\r\n  border: 1px solid #fca5a5;\r\n}\r\n\r\n@keyframes slideDown {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.criteria-section {\r\n  max-width: 300px;\r\n}\r\n\r\n.criteria-label {\r\n  display: block;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  color: #374151;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.criteria-select {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  color: #374151;\r\n  background: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.criteria-select:hover {\r\n  border-color: #3b82f6;\r\n}\r\n\r\n.criteria-select:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.criteria-query-section {\r\n  display: grid;\r\n  grid-template-columns: 200px 1fr;\r\n  gap: 20px;\r\n  flex: 1;\r\n}\r\n\r\n.criteria-query-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.criteria-query-item {\r\n  padding: 10px 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background: white;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  text-align: left;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.criteria-query-item:hover {\r\n  border-color: #3b82f6;\r\n  background: #eff6ff;\r\n}\r\n\r\n.criteria-query-item.active {\r\n  border-color: #3b82f6;\r\n  background: #dbeafe;\r\n  font-weight: 500;\r\n}\r\n\r\n.criteria-query-item:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.criteria-override-badge {\r\n  font-size: 12px;\r\n  color: #f97316;\r\n  margin-left: auto;\r\n}\r\n\r\n.criteria-query-editor {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.criteria-query-textarea {\r\n  flex: 1;\r\n  min-height: 140px;\r\n  padding: 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  font-size: 12px;\r\n  font-family: var(--font-mono);\r\n  color: #374151;\r\n  background: white;\r\n  resize: vertical;\r\n}\r\n\r\n/* SELECT / INSERT 영역 비율 조정 — SELECT 가 더 자주 편집되므로 더 크게. */\r\n.criteria-query-textarea.select-area {\r\n  min-height: 200px;     /* SELECT — 넉넉히 */\r\n}\r\n.criteria-query-textarea.insert-area {\r\n  min-height: 80px;      /* INSERT — 짧게 (특히 builtin 자동생성 1줄 SQL) */\r\n}\r\n\r\n.criteria-group-label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  /* 묶음 사이는 보통의 실선 — 점선은 어색했다(2026-10-03) */\r\n  margin-top: 10px;\r\n  padding: 8px 2px 2px;\r\n  border-top: 1px solid #e5e7eb;\r\n}\r\n\r\n.criteria-group-label:first-child {\r\n  border-top: none;\r\n  margin-top: 0;\r\n}\r\n\r\n.criteria-group-label-with-action {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.criteria-btn-icon {\r\n  border: none;\r\n  background: #eef2ff;\r\n  color: #3b82f6;\r\n  border-radius: 4px;\r\n  width: 22px;\r\n  height: 22px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n\r\n.criteria-btn-icon:hover:not(:disabled) {\r\n  background: #c7d2fe;\r\n}\r\n\r\n.criteria-btn-icon:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.criteria-empty-hint {\r\n  font-size: 12px;\r\n  color: #9ca3af;\r\n  padding: 4px 2px;\r\n}\r\n\r\n/* 탭 진입 시 상단에 표시되는 안내 박스 (collapsible).\r\n   <details><summary>축약</summary><div>상세</div></details> 구조 사용. */\r\n.criteria-tab-intro {\r\n  font-size: 12px;\r\n  line-height: 1.5;\r\n  color: #4b5563;\r\n  background: #f0f7ff;\r\n  border: 1px solid #c7dcfa;\r\n  border-left: 3px solid #3b82f6;\r\n  border-radius: 4px;\r\n  padding: 8px 12px;\r\n  margin-bottom: 10px;\r\n}\r\n.criteria-tab-intro > summary {\r\n  cursor: pointer;\r\n  list-style: none;       /* 기본 화살표 marker 제거 (커스텀 표시 사용) */\r\n  user-select: none;\r\n  position: relative;\r\n  padding-left: 16px;\r\n  outline: none;\r\n}\r\n.criteria-tab-intro > summary::-webkit-details-marker { display: none; }\r\n/* 커스텀 화살표 — 접힘: ▶, 펼침: ▼ (open 시 회전) */\r\n.criteria-tab-intro > summary::before {\r\n  content: '▶';\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  font-size: 9px;\r\n  color: #3b82f6;\r\n  transition: transform 150ms ease;\r\n}\r\n.criteria-tab-intro[open] > summary::before {\r\n  transform: rotate(90deg);\r\n}\r\n.criteria-tab-intro .criteria-intro-more {\r\n  font-style: italic;\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n  margin-left: 4px;\r\n  font-weight: normal;\r\n}\r\n.criteria-tab-intro[open] .criteria-intro-more {\r\n  display: none;          /* 펼친 후엔 안내 텍스트 숨김 */\r\n}\r\n.criteria-tab-intro .criteria-intro-body {\r\n  margin-top: 8px;\r\n  padding-top: 8px;\r\n  border-top: 1px solid rgba(59, 130, 246, 0.25);\r\n}\r\n.criteria-tab-intro .criteria-intro-body ul {\r\n  margin: 0;\r\n  padding-left: 18px;\r\n  list-style: disc;\r\n}\r\n.criteria-tab-intro strong {\r\n  color: #1e3a8a;\r\n}\r\n.criteria-tab-intro code {\r\n  background: rgba(59, 130, 246, 0.12);\r\n  color: #1e40af;\r\n  padding: 0 4px;\r\n  border-radius: 3px;\r\n  font-family: var(--font-mono);\r\n  font-size: 11px;\r\n}\r\n\r\n/* 다크 모드 */\r\n[data-theme=\"dark\"] .criteria-tab-intro {\r\n  color: var(--color-text);\r\n  background: rgba(59, 130, 246, 0.08);\r\n  border-color: rgba(99, 130, 200, 0.4);\r\n  border-left-color: #6cb6ff;\r\n}\r\n[data-theme=\"dark\"] .criteria-tab-intro > summary::before { color: #6cb6ff; }\r\n[data-theme=\"dark\"] .criteria-tab-intro .criteria-intro-more { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .criteria-tab-intro .criteria-intro-body {\r\n  border-top-color: rgba(108, 182, 255, 0.25);\r\n}\r\n[data-theme=\"dark\"] .criteria-tab-intro strong { color: #93c5fd; }\r\n[data-theme=\"dark\"] .criteria-tab-intro code {\r\n  background: rgba(108, 182, 255, 0.18);\r\n  color: #93c5fd;\r\n}\r\n\r\n.criteria-field-row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.criteria-field-inline {\r\n  flex-direction: row;\r\n  gap: 12px;\r\n}\r\n\r\n.criteria-text-input {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  font-size: 12.5px;\r\n  color: #374151;\r\n  background: white;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.criteria-text-input:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.criteria-text-input:disabled {\r\n  opacity: 0.7;\r\n  background: #f3f4f6;\r\n}\r\n\r\n.criteria-query-textarea:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.criteria-query-textarea:disabled {\r\n  opacity: 0.6;\r\n  background: #f3f4f6;\r\n}\r\n\r\n.criteria-query-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.criteria-mapping-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  flex: 1;\r\n}\r\n\r\n.criteria-mapping-header {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 20px;\r\n}\r\n\r\n.criteria-mapping-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.criteria-mapping-table thead {\r\n  background: #f3f4f6;\r\n}\r\n\r\n.criteria-mapping-table th {\r\n  padding: 10px 12px;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #374151;\r\n  border-bottom: 1px solid #d1d5db;\r\n}\r\n\r\n.criteria-mapping-table td {\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  color: #374151;\r\n}\r\n\r\n.criteria-mapping-table tbody tr:hover {\r\n  background: #f9fafb;\r\n}\r\n\r\n.criteria-mapping-new {\r\n  background: #f9fafb;\r\n}\r\n\r\n.criteria-mapping-table input {\r\n  width: 100%;\r\n  padding: 6px 8px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n}\r\n\r\n.criteria-mapping-table input:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.criteria-type-select {\r\n  width: 100%;\r\n  padding: 6px 8px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.criteria-type-select:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.criteria-btn-delete,\r\n.criteria-btn-add {\r\n  padding: 6px 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.criteria-btn-delete {\r\n  background: #fee2e2;\r\n  color: #991b1b;\r\n}\r\n\r\n.criteria-btn-delete:hover:not(:disabled) {\r\n  background: #fca5a5;\r\n}\r\n\r\n.criteria-btn-delete:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.criteria-btn-add {\r\n  background: #d1fae5;\r\n  color: #065f46;\r\n}\r\n\r\n.criteria-btn-add:hover:not(:disabled) {\r\n  background: #6ee7b7;\r\n}\r\n\r\n.criteria-btn-add:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.criteria-mapping-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.criteria-btn {\r\n  padding: 8px 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.criteria-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.criteria-btn-primary {\r\n  background: #3b82f6;\r\n  color: white;\r\n}\r\n\r\n.criteria-btn-primary:hover:not(:disabled) {\r\n  background: #2563eb;\r\n}\r\n\r\n.criteria-btn-danger {\r\n  background: #ef4444;\r\n  color: white;\r\n}\r\n\r\n.criteria-btn-danger:hover:not(:disabled) {\r\n  background: #dc2626;\r\n}\r\n\r\n.criteria-btn-secondary {\r\n  background: #e5e7eb;\r\n  color: #374151;\r\n}\r\n\r\n.criteria-btn-secondary:hover:not(:disabled) {\r\n  background: #d1d5db;\r\n}\r\n\r\n.criteria-modal-footer {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 16px 20px;\r\n  border-top: 1px solid #e5e7eb;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* Dark mode */\r\n[data-theme=\"dark\"] .criteria-modal {\r\n  background: var(--color-bg-tertiary);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-modal-header {\r\n  background: var(--color-bg-secondary);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-modal-header h2 {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-modal-close {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-modal-close:hover {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-modal-tabs {\r\n  background: var(--color-bg-secondary);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-tab {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-tab:hover {\r\n  background: var(--color-hover);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-tab.active {\r\n  color: var(--color-accent-fg);\r\n  background: var(--color-bg-tertiary);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-label {\r\n  color: var(--color-text-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-select {\r\n  background: var(--color-input-bg);\r\n  border-color: var(--color-input-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-select:hover {\r\n  border-color: var(--color-hover-border, #5a5a5a);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-select:focus {\r\n  border-color: var(--color-accent-fg);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-message-success {\r\n  background: #1a3a2a;\r\n  color: #4caf50;\r\n  border-color: #2e7d32;\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-message-error {\r\n  background: #3a1a1a;\r\n  color: #ef5350;\r\n  border-color: #c62828;\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-query-item {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-query-item:hover {\r\n  background: var(--color-hover);\r\n  border-color: var(--color-hover-border, #5a5a5a);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-query-item.active {\r\n  background: #264f78;\r\n  border-color: var(--color-accent-fg);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-query-textarea {\r\n  background: var(--color-input-bg);\r\n  border-color: var(--color-input-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-query-textarea:focus {\r\n  border-color: var(--color-accent-fg);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-query-textarea:disabled {\r\n  background: var(--color-bg-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-mapping-table {\r\n  border-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-mapping-table thead {\r\n  background: var(--color-bg-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-mapping-table th {\r\n  color: var(--color-text);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-mapping-table td {\r\n  border-bottom-color: var(--color-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-mapping-table tbody tr:hover {\r\n  background: var(--color-hover);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-mapping-new {\r\n  background: var(--color-bg-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-mapping-table input,\r\n[data-theme=\"dark\"] .criteria-type-select {\r\n  background: var(--color-input-bg);\r\n  border-color: var(--color-input-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-mapping-table input:focus,\r\n[data-theme=\"dark\"] .criteria-type-select:focus {\r\n  border-color: var(--color-accent-fg);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-modal-footer {\r\n  border-top-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-secondary {\r\n  background: var(--color-bg-secondary);\r\n  color: var(--color-text);\r\n  border: 1px solid var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-secondary:hover:not(:disabled) {\r\n  background: var(--color-hover);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-delete {\r\n  background: rgba(239, 68, 68, 0.2); /* Red tint */\r\n  color: #fca5a5;\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-delete:hover:not(:disabled) {\r\n  background: rgba(239, 68, 68, 0.4);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-add {\r\n  background: rgba(16, 185, 129, 0.2); /* Green tint */\r\n  color: #6ee7b7;\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-add:hover:not(:disabled) {\r\n  background: rgba(16, 185, 129, 0.4);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-primary {\r\n  background: #2563eb;\r\n  color: #fff;\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-primary:hover:not(:disabled) {\r\n  background: #1d4ed8;\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-icon {\r\n  background: rgba(59, 130, 246, 0.2);\r\n  color: #60a5fa;\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-icon:hover:not(:disabled) {\r\n  background: var(--color-hover);\r\n}\r\n\r\n/* ===== 스케줄 탭 (통합) ===== */\r\n.criteria-schedule-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  flex: 1;\r\n}\r\n\r\n.criteria-groups-table {\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.criteria-groups-table table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 12px;\r\n}\r\n\r\n.criteria-groups-table thead {\r\n  background: #f3f4f6;\r\n}\r\n\r\n.criteria-groups-table th {\r\n  padding: 12px;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #374151;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.criteria-groups-table td {\r\n  padding: 12px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  color: #374151;\r\n  vertical-align: middle;\r\n}\r\n\r\n.criteria-groups-table tbody tr:hover {\r\n  background: #f9fafb;\r\n}\r\n\r\n.criteria-status-badge {\r\n  display: inline-block;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n}\r\n\r\n.criteria-status-badge.active {\r\n  background: #d1fae5;\r\n  color: #065f46;\r\n}\r\n\r\n.criteria-status-badge.inactive {\r\n  background: #fee2e2;\r\n  color: #991b1b;\r\n}\r\n\r\n.criteria-schedule-actions {\r\n  display: flex;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.criteria-btn-small {\r\n  padding: 6px 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.criteria-btn-small:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.criteria-btn-small.criteria-btn-primary {\r\n  background: #3b82f6;\r\n  color: white;\r\n}\r\n\r\n.criteria-btn-small.criteria-btn-primary:hover:not(:disabled) {\r\n  background: #2563eb;\r\n}\r\n\r\n.criteria-btn-small.criteria-btn-success {\r\n  background: #10b981;\r\n  color: white;\r\n}\r\n\r\n.criteria-btn-small.criteria-btn-success:hover:not(:disabled) {\r\n  background: #059669;\r\n}\r\n\r\n.criteria-btn-small.criteria-btn-danger {\r\n  background: #ef4444;\r\n  color: white;\r\n}\r\n\r\n.criteria-btn-small.criteria-btn-danger:hover:not(:disabled) {\r\n  background: #dc2626;\r\n}\r\n\r\n.criteria-btn-small.criteria-btn-secondary {\r\n  background: #e5e7eb;\r\n  color: #374151;\r\n}\r\n\r\n.criteria-btn-small.criteria-btn-secondary:hover:not(:disabled) {\r\n  background: #d1d5db;\r\n}\r\n\r\n.criteria-select-inline {\r\n  padding: 4px 8px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  background: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.criteria-select-inline:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n/* ===== 스케줄 탭 — 다크모드 ===== */\r\n[data-theme=\"dark\"] .criteria-groups-table {\r\n  border-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-groups-table thead {\r\n  background: var(--color-bg-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-groups-table th {\r\n  color: var(--color-text);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-groups-table td {\r\n  border-bottom-color: var(--color-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-groups-table tbody tr:hover {\r\n  background: var(--color-hover);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-status-badge.active {\r\n  background: rgba(16, 185, 129, 0.2);\r\n  color: #6ee7b7;\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-status-badge.inactive {\r\n  background: rgba(239, 68, 68, 0.2);\r\n  color: #fca5a5;\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-select-inline {\r\n  background: var(--color-input-bg);\r\n  border-color: var(--color-input-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-select-inline:focus {\r\n  border-color: var(--color-accent-fg);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-small.criteria-btn-secondary {\r\n  background: var(--color-bg-secondary);\r\n  color: var(--color-text);\r\n  border: 1px solid var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-small.criteria-btn-secondary:hover:not(:disabled) {\r\n  background: var(--color-hover);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-small.criteria-btn-danger {\r\n  background: rgba(239, 68, 68, 0.2);\r\n  color: #fca5a5;\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-small.criteria-btn-danger:hover:not(:disabled) {\r\n  background: rgba(239, 68, 68, 0.4);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-small.criteria-btn-success {\r\n  background: rgba(16, 185, 129, 0.2);\r\n  color: #6ee7b7;\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-small.criteria-btn-success:hover:not(:disabled) {\r\n  background: rgba(16, 185, 129, 0.4);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-small.criteria-btn-primary {\r\n  background: #2563eb;\r\n  color: #fff;\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-btn-small.criteria-btn-primary:hover:not(:disabled) {\r\n  background: #1d4ed8;\r\n}\r\n\r\n/* ===== 스케줄 — 펼침/타입 뱃지/요약/상세 이력 ===== */\r\n.criteria-expand-btn {\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  color: #6b7280;\r\n  font-size: 10px;\r\n  padding: 2px 4px;\r\n  line-height: 1;\r\n  border-radius: 3px;\r\n}\r\n\r\n.criteria-expand-btn:hover {\r\n  background: #e5e7eb;\r\n  color: #111827;\r\n}\r\n\r\n.criteria-group-name-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.criteria-group-name {\r\n  font-weight: 500;\r\n}\r\n\r\n.criteria-type-badge {\r\n  display: inline-block;\r\n  padding: 1px 6px;\r\n  border-radius: 10px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.02em;\r\n  line-height: 1.5;\r\n  white-space: nowrap;\r\n}\r\n\r\n.criteria-type-builtin {\r\n  background: #dbeafe;\r\n  color: #1e40af;\r\n  border: 1px solid #bfdbfe;\r\n}\r\n\r\n.criteria-type-custom {\r\n  background: #fef3c7;\r\n  color: #92400e;\r\n  border: 1px solid #fde68a;\r\n}\r\n\r\n.criteria-summary-cell {\r\n  font-size: 12px;\r\n  color: #374151;\r\n  min-width: 170px;\r\n}\r\n\r\n.criteria-summary-label {\r\n  color: #6b7280;\r\n}\r\n\r\n.criteria-summary-sub {\r\n  color: #9ca3af;\r\n  font-size: 11px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.criteria-row-expanded > td {\r\n  background: #f3f4f6;\r\n}\r\n\r\n.criteria-row-detail > td {\r\n  padding: 0 !important;\r\n  background: #fafafa;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.criteria-history-detail {\r\n  padding: 12px 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.criteria-history-head {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #374151;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n}\r\n\r\n.criteria-history-tablewrap {\r\n  max-height: 280px;\r\n  overflow: auto;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 4px;\r\n  background: white;\r\n}\r\n\r\n.criteria-history-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 12px;\r\n  font-family: var(--font-mono);\r\n}\r\n\r\n.criteria-history-table th {\r\n  position: sticky;\r\n  top: 0;\r\n  background: #f3f4f6;\r\n  color: #374151;\r\n  font-weight: 600;\r\n  padding: 6px 8px;\r\n  border-bottom: 1px solid #d1d5db;\r\n  text-align: left;\r\n  white-space: nowrap;\r\n}\r\n\r\n.criteria-history-table td {\r\n  padding: 5px 8px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  color: #374151;\r\n  white-space: nowrap;\r\n  max-width: 320px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.criteria-history-table tbody tr:hover {\r\n  background: #fafafa;\r\n}\r\n\r\n/* ===== 스케줄 — 다크모드 보강 ===== */\r\n[data-theme=\"dark\"] .criteria-expand-btn {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-expand-btn:hover {\r\n  background: var(--color-hover);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-type-builtin {\r\n  background: rgba(59, 130, 246, 0.2);\r\n  color: #93c5fd;\r\n  border-color: rgba(59, 130, 246, 0.4);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-type-custom {\r\n  background: rgba(245, 158, 11, 0.2);\r\n  color: #fcd34d;\r\n  border-color: rgba(245, 158, 11, 0.4);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-summary-cell {\r\n  color: var(--color-text-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-summary-label,\r\n[data-theme=\"dark\"] .criteria-summary-sub {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-row-expanded > td {\r\n  background: var(--color-hover);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-row-detail > td {\r\n  background: var(--color-bg-secondary);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-history-tablewrap {\r\n  background: var(--color-bg-tertiary);\r\n  border-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-history-table th {\r\n  background: var(--color-bg-secondary);\r\n  color: var(--color-text);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-history-table td {\r\n  color: var(--color-text);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .criteria-history-table tbody tr:hover {\r\n  background: var(--color-hover);\r\n}\r\n\r\n/* ===== 오라클 성능 분석과 모양 맞춤 (2026-10-03) =====\r\n   앞의 규칙은 두고 뒤에서 덮는다. 다크 규칙([data-theme] 이 붙어 더 구체적)은 그대로 이긴다. */\r\n.criteria-modal-tabs {\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 0 16px;\r\n  background: #f8f9fa;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n.criteria-tab {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 10px 12px;\r\n  font-size: 13px;\r\n  white-space: nowrap;\r\n  transition: color 150ms ease, border-color 150ms ease;\r\n}\r\n.criteria-tab:hover { background: none; }\r\n.criteria-tab.active { background: none; }\r\n.criteria-tab > svg { display: block; flex-shrink: 0; }\r\n.criteria-workpane-body { padding: 14px 16px; gap: 14px; }\r\n.criteria-sidebar { padding: 12px 10px; }\r\n.criteria-query-item { padding: 7px 10px; font-size: 12.5px; border-radius: 5px; transition: background-color 150ms ease, border-color 150ms ease; }\r\n.criteria-query-item.active { background: rgba(59, 130, 246, 0.1); color: #1d4ed8; font-weight: 600; }\r\n.criteria-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  height: 30px;\r\n  box-sizing: border-box;\r\n  padding: 0 14px;\r\n  border: 1px solid transparent;\r\n  font-size: 13px;\r\n  line-height: 1;\r\n  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;\r\n}\r\n.criteria-btn-secondary { border-color: #d1d5db; }\r\n.criteria-btn-small { transition: background-color 150ms ease, color 150ms ease; }\r\n.criteria-select { padding: 0 10px; height: 30px; font-size: 12.5px; border-radius: 4px; }\r\n.criteria-modal-footer { padding: 10px 16px; background: #f8f9fa; border-top-color: #e0e0e0; }\r\n[data-theme=\"dark\"] .criteria-modal-tabs { background: var(--color-bg-secondary); border-bottom-color: var(--color-border); }\r\n[data-theme=\"dark\"] .criteria-tab:hover, [data-theme=\"dark\"] .criteria-tab.active { background: none; }\r\n[data-theme=\"dark\"] .criteria-query-item.active { background: rgba(59, 130, 246, 0.18); color: #93c5fd; }\r\n[data-theme=\"dark\"] .criteria-modal-footer { background: var(--color-bg-secondary); border-top-color: var(--color-border); }\r\n@media (prefers-reduced-motion: reduce) {\r\n  .criteria-tab, .criteria-query-item, .criteria-btn, .criteria-btn-small { transition: none; }\r\n}\r\n[data-theme=\"dark\"] .criteria-group-label { border-top-color: var(--color-border); }\r\n\r\n/* ===== 세션 분석 · 오라클 성능 분석 기준으로 맞춤 (2026-10-03, 모니터링 메뉴 4개 창 공통) =====\r\n   본문 12px · 표(머리 6/8px 회색 바탕 + 아래 2px 선, 칸 5/8px + 1px 선) · 버튼·입력 30px · 필터는 리본 · 발 영역 회색 줄.\r\n   앞 규칙을 지우지 않고 뒤에서 덮는다(분리 창·전체 화면이 같은 클래스를 쓴다). 색 전환만(all 트랜지션 아님). */\r\n.criteria-label { font-size: 12px; font-weight: 600; }\r\n.criteria-text-input { height: 30px; box-sizing: border-box; padding: 0 10px; font-size: 12.5px; border-radius: 4px; }\r\n.criteria-mapping-table, .criteria-groups-table table, .criteria-history-table { font-size: 12px; }\r\n.criteria-mapping-table th, .criteria-groups-table th, .criteria-history-table th {\r\n  padding: 6px 8px; background: #f8f9fa; border-bottom: 2px solid #d0d5db; color: #333; font-weight: 600; white-space: nowrap;\r\n}\r\n.criteria-mapping-table td, .criteria-groups-table td, .criteria-history-table td { padding: 5px 8px; border-bottom: 1px solid #eee; color: #374151; }\r\n[data-theme=\"dark\"] .criteria-mapping-table th, [data-theme=\"dark\"] .criteria-groups-table th, [data-theme=\"dark\"] .criteria-history-table th {\r\n  background: var(--color-bg-secondary); border-bottom-color: var(--color-border); color: var(--color-text);\r\n}\r\n[data-theme=\"dark\"] .criteria-mapping-table td, [data-theme=\"dark\"] .criteria-groups-table td, [data-theme=\"dark\"] .criteria-history-table td {\r\n  border-bottom-color: var(--color-border); color: var(--color-text);\r\n}\r\n\n/* 적재 대상이 내장 저장소일 때의 안내(2026-10-28) */\n.criteria-hint { margin-top: 4px; font-size: 11px; line-height: 1.5; color: var(--color-text-muted, #888); animation: criteria-hint-fade 150ms ease-out; }\n@keyframes criteria-hint-fade { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }\n@media (prefers-reduced-motion: reduce) { .criteria-hint { animation: none; } }\n\n/* ===== 2026-10-28 구조 개편 — 왼쪽 연결 목록 · 위쪽 기준 목록 · 연결별 수집 설정 카드 ===== */\n.criteria-conn-item { display: flex; flex-direction: column; align-items: flex-start; gap: 2px; text-align: left; }\n.criteria-conn-name { font-weight: 600; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.criteria-conn-sub { font-size: 11px; color: var(--color-text-muted, #888); font-weight: 400; }\n.criteria-conn-sub.on { color: #16a34a; }\n\n.criteria-topbar {\n  display: flex; flex-wrap: wrap; align-items: center; gap: 4px 6px;\n  padding: 8px 14px; border-bottom: 1px solid var(--color-border, #e5e7eb);\n  animation: criteria-topbar-fade 150ms ease-out;\n}\n.criteria-topbar-label { font-size: 11px; font-weight: 600; color: var(--color-text-muted, #6b7280); margin-right: 2px; }\n.criteria-topbar-sep { width: 1px; height: 18px; background: var(--color-border, #e5e7eb); margin: 0 4px; }\n.criteria-topbar-empty { font-size: 11px; color: var(--color-text-muted, #999); }\n.criteria-chip {\n  display: inline-flex; align-items: center; gap: 4px;\n  padding: 3px 10px; border: 1px solid var(--color-border, #d1d5db); border-radius: 12px;\n  background: var(--color-bg, #fff); color: var(--color-text, #374151); font-size: 12px; cursor: pointer;\n  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n.criteria-chip:hover:not(:disabled) { border-color: #3b82f6; }\n.criteria-chip.active { border-color: #3b82f6; background: color-mix(in srgb, #3b82f6 14%, transparent); color: var(--color-accent, #2563eb); font-weight: 600; }\n.criteria-chip:disabled { opacity: 0.6; cursor: not-allowed; }\n.criteria-chip-star { color: #f97316; }\n.criteria-scope { padding: 6px 14px; font-size: 11.5px; color: var(--color-text-secondary, #555); background: var(--color-bg-secondary, #f8fafc); border-bottom: 1px solid var(--color-border, #e5e7eb); transition: background-color 150ms ease, color 150ms ease; }\n.criteria-scope.conn { background: color-mix(in srgb, #f97316 10%, transparent); color: var(--color-text, #222); }\n.criteria-schedule-section .criteria-schedule-card + .criteria-schedule-card { margin-top: 10px; }\n[data-theme=\"dark\"] .criteria-chip { background: #2b2b2b; border-color: #444; color: #ddd; }\n[data-theme=\"dark\"] .criteria-scope { background: #252526; }\n\n@keyframes criteria-topbar-fade { from { opacity: 0; transform: translateY(-3px); } to { opacity: 1; transform: translateY(0); } }\n@media (prefers-reduced-motion: reduce) {\n  .criteria-topbar { animation: none; }\n  .criteria-chip, .criteria-scope { transition: none; }\n}\n.criteria-message-info { background: #dbeafe; color: #1e3a8a; border: 1px solid #93c5fd; }\n[data-theme=\"dark\"] .criteria-message-info { background: #1e2a44; color: #93c5fd; border-color: #2c4a7a; }\n/* 연결별 수집 설정 표(2026-10-28) */\n.criteria-sched-table { width: 100%; border-collapse: collapse; font-size: 12.5px; margin-top: 8px; animation: criteria-topbar-fade 150ms ease-out; }\n.criteria-sched-table th { text-align: left; font-weight: 600; font-size: 11.5px; color: var(--color-text-muted, #6b7280); padding: 6px 8px; border-bottom: 1px solid var(--color-border, #e5e7eb); white-space: nowrap; }\n.criteria-sched-table td { padding: 6px 8px; border-bottom: 1px solid var(--color-border, #eef0f3); vertical-align: middle; }\n.criteria-sched-table tbody tr { transition: background-color 150ms ease; }\n.criteria-sched-table tbody tr:hover { background: var(--color-hover, rgba(0, 0, 0, 0.03)); }\n.criteria-sched-table .criteria-select { padding: 3px 6px; font-size: 12px; }\n.criteria-sched-actions { white-space: nowrap; text-align: right; }\n.criteria-sched-actions .criteria-btn-small + .criteria-btn-small { margin-left: 4px; }\n.criteria-sched-detail > td { background: var(--color-bg-secondary, #f8fafc); }\n[data-theme=\"dark\"] .criteria-sched-detail > td { background: #252526; }\n@media (prefers-reduced-motion: reduce) { .criteria-sched-table { animation: none; } .criteria-sched-table tbody tr { transition: none; } }\n/* 표가 칸보다 넓으면 표만 가로로 — 바깥 칸이 밀려 왼쪽 연결 목록 밑으로 들어갔다(2026-10-28 화면 확인) */\n.criteria-workpane { min-width: 0; }\n.criteria-workpane-body { overflow-x: hidden; }\n.criteria-sched-wrap { overflow-x: auto; max-width: 100%; }\n.criteria-body-split > .criteria-sidebar { position: relative; z-index: 1; }\n.criteria-sched-actions { white-space: normal; }\n.criteria-sched-actions > * { margin: 2px 0 2px 4px; }\n.criteria-sched-actions .criteria-btn-small + .criteria-btn-small { margin-left: 4px; }\n.criteria-sched-table td:not(.criteria-sched-actions) { white-space: nowrap; }\n.criteria-sched-table td:first-child { white-space: normal; }\n.criteria-sched-actions { white-space: nowrap; }\n.criteria-icon-act {\n  display: inline-flex; align-items: center; justify-content: center; width: 26px; height: 26px; margin-left: 3px;\n  border: 1px solid var(--color-border, #d1d5db); border-radius: 5px; background: var(--color-bg, #fff); color: var(--color-text-secondary, #555); cursor: pointer;\n  transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;\n}\n.criteria-icon-act:hover:not(:disabled), .criteria-icon-act.on { border-color: #3b82f6; color: #2563eb; }\n.criteria-icon-act.primary { color: #2563eb; }\n.criteria-icon-act.danger { color: #dc2626; }\n.criteria-icon-act:disabled { opacity: 0.5; cursor: not-allowed; }\n[data-theme=\"dark\"] .criteria-icon-act { background: #2b2b2b; border-color: #444; color: #ccc; }\n@media (prefers-reduced-motion: reduce) { .criteria-icon-act { transition: none; } }\n.criteria-body-split > .criteria-sidebar { width: 200px; min-width: 180px; }\n.criteria-sched-table th, .criteria-sched-table td { padding: 5px 6px; }\n.criteria-sched-table td:first-child { min-width: 96px; }\n.criteria-sched-table td:first-child .criteria-type-badge { margin-left: 0; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
